import "../styles/rigRackStyles.scss";
import { map } from "lodash/collection";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as sparesActions from "../redux/actions/sparesActions";
import ListEmptyComponent from "../components/ListEmptyComponent";
import LoadingComponent from "../components/LoadingComponent";
import imageResolver from "../helpers/imageResolver";

const SparePartsServiceable = ({ title, typeID, isAssembly }) => {
	const dispatch = useDispatch();
	const [pages, setPages] = useState(null);
	const [visible, setVisible] = useState(true);

	const { totalPages, currentPage, serviceable, active } = useSelector(state => state.sparesReducer);

	useEffect(() => {
		if (isAssembly)
			dispatch(sparesActions.loadCompositeServiceableSpares({ componentType: typeID }));
		else
			dispatch(sparesActions.loadServiceableSpares({ componentType: typeID }));

	}, [dispatch, typeID]);

	useEffect(() => {
		if (totalPages <= 0) setVisible(false);
		else {
			setVisible(true);
			let innerArr = Array(totalPages).fill("");
			setPages(innerArr);
		}
	}, [totalPages]);

	const renderItem = (sItem, key) => {
		return isAssembly ? renderCompositeItem(sItem, key) : renderNonCompositeItem(sItem, key)
	};

	const renderNonCompositeItem = (sItem, key) => {
		const resolveSubText = (item) => {
			if (item) {
				if (item.totalNumberOfDays !== null) {
					return `${item.totalNumberOfDays} (days)`;
				} else if (item.totalNumberOfJumps !== null) {
					return `${item.totalNumberOfJumps} (jumps)`;
				} else {
					return "N/A";
				}
			} else {
				return "N/A";
			}
		};

		return (
			<div key={key} className={"row mx-0 spare-parts-list"}>
				<div className={" serial-number"}>
					<span className={"float-start d-inline-flex"}><img
						src={sItem.requiredNumberOfSubComponents > 0 ?
							sItem.subComponents[0].imageUrl :
							sItem.imageUrl} alt="sparePart"
						className="src" /></span>
					<h4>{sItem.requiredNumberOfSubComponents > 0 ? sItem.subComponents[0].customID : sItem.customID}</h4>
				</div>
				<div className={"spare-parts-time"}>
					<h4> {resolveSubText(sItem.requiredNumberOfSubComponents > 0 ?
						sItem.subComponents[0].alertInfo :
						sItem.alertInfo)}</h4>
				</div>
			</div>
		);
	};

	const renderCompositeItem = (sItem, key) => {

		return (
			<div key={key} className={"row mx-0 spare-parts-list"}>
				<div className={"assemblyId"}>
					<span className={"float-start d-inline-flex"}><img
						src={imageResolver({componentType: 'ASSEMBLY'})} alt="sparePart"
						className="src" /></span>
					<h4>{sItem.assemblyId}</h4>
				</div>
			</div>
		);
	};

	if (!active && serviceable.length <= 0) return <ListEmptyComponent />;
	if (active) return <LoadingComponent />;
	else
		return (
			<div className={"spare-parts-serviceable-page"}>
				<div className={"d-none"}>
					{title}
				</div>
				<div>
					<div className={"spare-parts-table"}>
						<div className={"table-header-top"}>
							<div className={"float-start"}>
								<h3>{`Serviced ${title} Assembly List`}</h3>
							</div>
							<div className={"float-end ms-4 ps-3"}><h4>Items<span
								className={"ms-1"}>{serviceable.length}</span>
							</h4></div>
							{visible && <div className={"float-end"}><h4>Page <span
								className={"ms-1"}>{currentPage + 1}</span></h4>
							</div>}
						</div>
						{
							isAssembly ?
								<div className={"table-header row mx-0"}>
									<div className={"assemblyId"}><h4>Spare Part Assembly ID</h4></div>
								</div> :
								<div className={"table-header row mx-0"}>
									<div className={"serial-number"}><h4>Spare Part Custom Id
										Number</h4></div>
									<div className={"spare-parts-time"}><h4>Days / Jumps</h4>
									</div>
								</div>
						}
						<div className={"table-body"}>
							{map(serviceable, renderItem)}
						</div>
						{visible && <div className={"table-pagination"}>
							<div className={"float-start"}>
								{totalPages > 1 && <>
									<span>
										<BsArrowLeft color={"#687C97"} size={16} />
									</span>
									<label>Prev</label>
								</>}
							</div>
							<div className={"float-end"}>
								{totalPages > 1 && <>
									<label>Next</label>
									<span>
										<BsArrowRight color={"#687C97"} size={16} />
									</span>
								</>}
							</div>
							<div className={"clearfix"} />
							<div className={"d-flex justify-content-center"}>
								{
									map(pages, (item, index) => (
										<span key={index} className={index === currentPage ?
											"active" :
											""}>{index + 1}</span>
									))
								}
							</div>
						</div>}
					</div>
				</div>
			</div>
		);
};

export default SparePartsServiceable;
